function injectStyle (ssrContext) {
  require("!!vue-style-loader!css-loader?minimize!../../../../../../develop/node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-856302fa\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../../develop/node_modules/vue-loader/lib/selector?type=styles&index=0!./About.vue")
}
var Component = require("!../../../../../../develop/node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../../../develop/node_modules/vue-loader/lib/selector?type=script&index=0!./About.vue"),
  /* template */
  require("!!../../../../../../develop/node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-856302fa\",\"hasScoped\":true}!../../../../../../develop/node_modules/vue-loader/lib/selector?type=template&index=0!./About.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-856302fa",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/pages/About.vue
// module id = 397
// module chunks = 0